import type { BrandConfig } from '../branding.types';

/**
 * Catalyzed brand configuration - Default brand
 */
export const catalyzedBrand: BrandConfig = {
  id: 'catalyzed',
  name: 'Catalyzed',
  displayName: 'Catalyzed',
  tagline: 'AI-powered regulated industry analysis',
  
  assets: {
    logo: {
      light: '/brands/catalyzed/logo.png',
      dark: '/brands/catalyzed/logo_dark.png',
      favicon: '/brands/catalyzed/logo.png', // Using logo as favicon for now
    },
  },
  
  theme: {
    // Primary colors
    colorPrimary: '#0089AF',
    colorPrimaryBg: '#E6F7FB',
    colorPrimaryBgHover: '#BAE7F5',
    colorPrimaryBorder: '#87D8ED',
    colorPrimaryBorderHover: '#5CC5E0',
    colorPrimaryHover: '#00A3CC',
    colorPrimaryActive: '#006A8A',
    colorPrimaryTextHover: '#00A3CC',
    colorPrimaryText: '#0089AF',
    colorPrimaryTextActive: '#006A8A',
    
    // Link and info colors
    colorLink: '#0089AF',
    colorLinkHover: '#00A3CC',
    colorLinkActive: '#006A8A',
    colorInfo: '#0089AF',
    
    // Optional: Typography
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  
  metadata: {
    title: 'Catalyzed Platform',
    titleTemplate: '%s | Catalyzed Platform',
    description: 'AI-powered software platform for analyzing complex regulated industries',
    keywords: ['AI', 'regulated industries', 'analysis', 'compliance', 'automation'],
  },
  
  text: {
    welcomeMessage: 'Welcome to Catalyzed Platform',
    loginTitle: 'Sign in to Catalyzed',
    loginSubtitle: 'AI-powered regulated industry analysis',
    supportEmail: 'support@catalyzed.ai',
    billingEmail: 'billing@moderately.ai',
  },
  
  features: {
    showLogo: true,
    showTagline: true,
    customLoginPage: false,
  },
};

/**
 * Development version of Catalyzed brand
 */
export const catalyzedDevBrand: BrandConfig = {
  ...catalyzedBrand,
  id: 'catalyzed-dev',
  name: 'Catalyzed Dev',
  displayName: 'Catalyzed (Development)',
  metadata: {
    ...catalyzedBrand.metadata,
    title: 'Catalyzed Dev Platform',
    titleTemplate: '%s | Catalyzed Dev',
  },
};